import { create } from "zustand";

interface ScrollState {
  unreadCount: Record<string, number>;
  showScrollDown: Record<string, boolean>;
  hasScrolled: Record<string, boolean>;
  scrollPosition: Record<string, number>;
  userHasScrolledManually: Record<string, boolean>;
  scrollToMessageRef: Record<string, ((chatId: string, msgId: string) => void) | null>;

  setUnreadCount: (chatId: string, count: number) => void;
  setShowScrollDown: (chatId: string, value: boolean) => void;
  setHasScrolled: (chatId: string, value: boolean) => void;
  setscrollPosition: (chatId: string, value: number) => void;
  setUserHasScrolledManually: (chatId: string, value: boolean) => void;
  setScrollToMessage: (chatId: string, fn: ((chatId: string, msgId: string) => void) | null) => void;
  getScrollToMessage: (chatId: string) => ((chatId: string, msgId: string) => void) | null;
  resetChat: (chatId: string) => void;
}

export const useScrollStore = create<ScrollState>((set, get) => ({
  unreadCount: {},
  showScrollDown: {},
  hasScrolled: {},
  scrollPosition: {},

  userHasScrolledManually: {},
  scrollToMessageRef: {},

  setUserHasScrolledManually: (chatId, value) => {
    const current = get().userHasScrolledManually[chatId];
    if (current === value) return;
    set((state) => ({
      userHasScrolledManually: { ...state.userHasScrolledManually, [chatId]: value },
    }));
  },

  setUnreadCount: (chatId, count) => {
    const current = get().unreadCount[chatId];
    if (current === count) return;
    set((state) => ({
      unreadCount: { ...state.unreadCount, [chatId]: count },
    }));
  },

  setShowScrollDown: (chatId, value) => {
    const current = get().showScrollDown[chatId];
    if (current === value) return; 
    set((state) => ({
      showScrollDown: { ...state.showScrollDown, [chatId]: value },
    }));
  },

  setHasScrolled: (chatId, value) => {
    const current = get().hasScrolled[chatId];
    if (current === value) return;
    
    set((state) => ({
      hasScrolled: { ...state.hasScrolled, [chatId]: value },
    }));
  },

  setscrollPosition: (chatId, value) => {
    const current = get().scrollPosition[chatId];
    if (current === value) return;
    set((state) => ({
      scrollPosition: { ...state.scrollPosition, [chatId]: value },
    }));
  },
  
  setScrollToMessage: (chatId, fn) => {
    set((state) => ({
      scrollToMessageRef: { ...state.scrollToMessageRef, [chatId]: fn },
    }));
  },

  getScrollToMessage: (chatId) => {
    return get().scrollToMessageRef[chatId] ?? null;
  },

  resetChat: (chatId) => {
    set((state) => {
      // state.unreadCount[chatId] = 0;
      // state.showScrollDown[chatId] = false; 
      // state.scrollPosition[chatId] = 0; // сброс позиции скролла
      state.hasScrolled[chatId] = false;
      state.scrollToMessageRef[chatId] = null;
      // state.userHasScrolledManually[chatId] = false;
  
      // console.log("resetChat", state);
      
      return { ...state };
    });
  },
  
}));